import { useMemo } from 'react';
import useConfiguration from '~/configuration/use-configuration';
import enhanceImageView from '~/components/casino-shared/utilities/enhanceImage';
import { createImageViewFactory, getSmallestSrcFromSrcSet, ImageView } from '~/components/utilities/image-format';

const createImageView = (
	image: ImageView,
	imageDescriptors: ReturnType<typeof useConfiguration>['imageDescriptors'],
	imageFormats: ReturnType<typeof useConfiguration>['imageFormats']
) => {
	const imageView = enhanceImageView(
		image,
		imageDescriptors,
		createImageViewFactory(imageFormats, imageDescriptors),
		false
	);

	return {
		...imageView,
		smallestSrc: getSmallestSrcFromSrcSet(imageView.srcSet)
	};
};

const useImageView = (image: ImageView) => {
	const { imageDescriptors, imageFormats } = useConfiguration();

	const imageView = useMemo(
		() => createImageView(image, imageDescriptors, imageFormats),
		[image, imageDescriptors, imageFormats]
	);

	return imageView;
};

export default useImageView;
